var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
// import * as deliveryMethodFactory from '../../../classes/definitions/deliveryMethod/deliveryMethod';
import * as freeShippingFactory from '../../../classes/definitions/deliveryMethod/freeShipping';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import freeShippingSchema from "../../../schemas/freeShippingSchema";
// import freeShippingSchema from "../../../schemas/freeShippingSchema";
import Input from '../../UI/Input/Input';
var FreeShippingForm = /** @class */ (function (_super) {
    __extends(FreeShippingForm, _super);
    function FreeShippingForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(freeShippingSchema),
            formIsValid: false,
            discardPopupVisble: false
        };
        _this.getFreeShipping = function () {
            _this.api.getFreeShipping()
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на данните за доставка';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var freeShipping = freeShippingFactory.createFreeShipping(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'free_shipping_for_logged_users.value', freeShipping.FreeShippingActive ? 'true' : 'false');
            _.set(updatedFormConfig, 'free_shipping_for_logged_users.touched', true);
            _.set(updatedFormConfig, 'free_shipping_for_logged_users.valid', true);
            // _.set(updatedFormConfig, 'first_order_adjustment_available.value', freeShipping.FirstOrderActive ? 'true' : 'false');
            // _.set(updatedFormConfig, 'first_order_adjustment_available.touched', true);
            // _.set(updatedFormConfig, 'first_order_adjustment_available.valid', true);
            // _.set(updatedFormConfig, 'first_order_adjustment_percent.value', freeShipping.FirstOrderPercent);
            // _.set(updatedFormConfig, 'first_order_adjustment_percent.touched', true);
            // _.set(updatedFormConfig, 'first_order_adjustment_percent.valid', true);
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'inputSwitch') {
                updatedFormElement.value = event.target.value.toString();
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            // Create the submittedData object
            var submittedData = {
                configuration: {
                    free_shipping_for_logged_users: _.get(formData, 'free_shipping_for_logged_users.value', false) === 'true',
                }
            };
            // Use the updateFreeShipping method directly
            _this.api.updateFreeShipping(submittedData)
                .then(function (response) {
                _this.toDeliveryMethodsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при промяната';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toDeliveryMethodsPage = function () {
            _this.props.history.push(AppRoutes.deliveryMethods.path);
        };
        return _this;
    }
    FreeShippingForm.prototype.componentDidMount = function () {
        this.getFreeShipping();
    };
    FreeShippingForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, 
                // changed={(event: any) => this.eventHandlers(event, formElement.id, 'onChange')}
                changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, 
                // blur={(event: any) => this.eventHandlers(event, formElement.id, 'onBlur')}
                blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toDeliveryMethodsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return FreeShippingForm;
}(React.Component));
// @ts-ignore
export default withRouter(FreeShippingForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/DeliveryMethods/FreeShippingForm/FreeShippingForm.tsx
// module id = 347
// module chunks = 0